import _ from 'lodash';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { FormattedCurrency } from '../../../iwIntlProvider/FormattedCurrency';
import IwMedia from '../../../iwMedia/IwMedia';
import messages from './RepaymentScheduleTable.messages';

import {
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TableHeader,
    TableRow
} from '../../../myAccount/ui/elements/Table/Table';

export const RepaymentScheduleTable = ({
    hasFees,
    totalPrincipal,
    totalInterest,
    totalRepayment,
    totalFees,
    repayments
}: {
    hasFees: boolean;
    totalPrincipal: number;
    totalInterest: number;
    totalRepayment: number;
    totalFees: number;
    repayments: {
        date: string;
        interest: number;
        principal: number;
        total: number;
        total_fees: number;
    }[];
}) => {
    const getTableData = () => {
        const rows = _.map(repayments, (repayment, index) => {
            return (
                <TableRow key={index} data-testid="repayment-row">
                    <IwMedia to="small">
                        <TableCell className={'align-top'}>
                            <FormattedDate
                                value={new Date(repayment.date)}
                                day="numeric"
                                month="numeric"
                                year="2-digit"
                            />
                        </TableCell>
                        <TableCell colSpan={2}>
                            <span className={'pr-xs'}>
                                <FormattedMessage {...messages.principal} />:
                            </span>
                            <FormattedCurrency value={repayment.principal} />
                            <br />
                            <span className={'pr-xs'}>
                                <FormattedMessage {...messages.interest} />:
                            </span>
                            <FormattedCurrency value={repayment.interest} />
                            {hasFees && (
                                <>
                                    <br />
                                    <span className={'pr-xs'}>
                                        <FormattedMessage {...messages.fees} />:
                                    </span>
                                    <FormattedCurrency
                                        value={repayment.total_fees}
                                    />
                                </>
                            )}
                        </TableCell>
                        <TableCell className={'align-top'}>
                            <FormattedCurrency value={repayment.total} />
                        </TableCell>
                    </IwMedia>
                    <IwMedia from="small">
                        <TableCell>
                            <FormattedDate value={new Date(repayment.date)} />
                        </TableCell>
                        <TableCell>
                            <FormattedCurrency value={repayment.principal} />
                        </TableCell>
                        <TableCell>
                            <FormattedCurrency value={repayment.interest} />
                        </TableCell>
                        {hasFees && (
                            <TableCell>
                                <FormattedCurrency
                                    value={repayment.total_fees}
                                />
                            </TableCell>
                        )}
                        <TableCell>
                            <FormattedCurrency value={repayment.total} />
                        </TableCell>
                    </IwMedia>
                </TableRow>
            );
        });

        if (repayments.length < 12) {
            return [
                ...rows,
                // eslint-disable-next-line react/jsx-key
                <TableRow>
                    <TableCell colSpan={4}>
                        <div>
                            <p>
                                <FormattedMessage {...messages.payOff} />
                            </p>
                            <p>
                                <FormattedMessage {...messages.extraPayments} />
                            </p>
                        </div>
                    </TableCell>
                </TableRow>
            ];
        }

        return rows;
    };

    return (
        <Table>
            <TableHeader>
                <TableRow>
                    <IwMedia to="small">
                        <TableHead>
                            <FormattedMessage {...messages.date} />
                        </TableHead>
                        <TableHead colSpan={2}>
                            <FormattedMessage {...messages.split} />
                        </TableHead>
                        <TableHead>
                            <FormattedMessage {...messages.total} />
                        </TableHead>
                    </IwMedia>

                    <IwMedia from="small">
                        <TableHead>
                            <FormattedMessage {...messages.date} />
                        </TableHead>
                        <TableHead>
                            <FormattedMessage {...messages.principal} />
                        </TableHead>
                        <TableHead>
                            <FormattedMessage {...messages.interest} />
                        </TableHead>

                        {hasFees && (
                            <TableHead>
                                <FormattedMessage {...messages.fees} />
                            </TableHead>
                        )}

                        <TableHead>
                            <FormattedMessage {...messages.totalRepayment} />
                        </TableHead>
                    </IwMedia>
                </TableRow>
            </TableHeader>

            <TableBody>{getTableData()}</TableBody>

            <TableFooter>
                <TableRow>
                    <IwMedia to="small">
                        <TableCell colSpan={3}>
                            <FormattedMessage {...messages.total} />:
                        </TableCell>
                    </IwMedia>

                    <IwMedia from="small">
                        <TableCell>
                            <FormattedMessage {...messages.total} />:
                        </TableCell>
                        <TableCell data-testid="total-principal">
                            <FormattedCurrency value={totalPrincipal} />
                        </TableCell>
                        <TableCell data-testid="total-interest">
                            <FormattedCurrency value={totalInterest} />
                        </TableCell>

                        {hasFees && (
                            <TableCell>
                                <FormattedCurrency value={totalFees} />
                            </TableCell>
                        )}
                    </IwMedia>

                    <TableCell data-testid="total-balance">
                        <FormattedCurrency value={totalRepayment} />
                    </TableCell>
                </TableRow>
            </TableFooter>
        </Table>
    );
};
